export default __webpack_public_path__ + "static/Finnomena_new logo-23a230b76af2efc9bd4ef45b616fd253.png";